<template>
    <div>

        <!-- Navbar itself -->
        <q-toolbar color="white" class="justify-between" v-if="user">

            <!-- Menu -->
            <div class="row tablet-width" :class="$q.screen.gt.md ? 'col-2' : 'col-7'" :style="$q.screen.gt.md ? 'max-width: 300px!important;' : ''">
              <div class="row justify-between">
                <v-button flat dense round @click="isHome" color="primary" :icon="removeLogo ? 'fa icon-hamburger-menu' : 'fa icon-light-menu'"
                          tour="briefing-2" :tour-title="$T('menu')"
                          :tour-content="$T('click here to access menu items')"
                          v-if="($route.name === 'home' && !isMobile) || isMobile"></v-button>
              </div>

              <q-toolbar-title :class="$q.screen.gt.sm || ($q.screen.gt.sm && $route.name === 'home') ? 'justify-start' : 'justify-end'" class="row tb-btn-height" :style="noBorder || ($route.name !== 'home' && $q.screen.gt.md) ? 'justify-content:center;' : ''">
                  <router-link :to="{ name: user ? 'home' : 'welcome' }" tour="briefing-3"
                              :tour-title="$T('dashboard')"
                              :tour-content="$T('click here to return to dashboard')">
                      <img v-if="!removeLogo && !isMobile" src="../../img/iqos/iqos_logo.svg" class="tb-btn-height gt-sm" :alt="appName"/>
                      <img v-if="removeLogo && !isMobile && $route.name === 'home'" src="../../img/iqos/iqos_logo.svg" class="tb-btn-height" :alt="appName"/>
                      <img v-if="isMobile" src="../../img/iqos/iqos_logo_mobile.svg" class="tb-btn-height" :alt="appName"/>
                  </router-link>
              </q-toolbar-title>

            </div>

            <lending-point-dropdown v-if="!isMobile && user && user.role && (user.role.name == 'Sales Expert' || user.role.name == 'MUPI' || user.role.name == 'Remote Coach')" tour="briefing-6"
                                    :useLabel = false
                                    :tour-title="$T('lending points')"
                                    :tour-content="$T('click here to switch between lending points')" class="row col-2 justify-center text-weight-bold" :style="$q.screen.gt.sm ? 'width:31vw;padding-left:44px;' : ''">
            </lending-point-dropdown>

            <div class="row">
              <div v-if="user && notificationEnabled === '1' && user.role && (user.role.name === 'Sales Expert' || user.role.name === 'MUPI' || user.role.name == 'Remote Coach' || user.role.name === 'Lending Point')">
                <q-btn v-if="total > 0" class="styled-btn-notification" flat rounded color="primary" @click.native="notificationsButtonClick" icon="fa icon-notification">
                  <div :class="isMobile ? 'chip-notifications-mobile' : 'chip-notifications-desktop'">{{ total }}</div>
                  <!-- <q-chip floating small color="highlight">{{ total }}</q-chip> -->
                </q-btn>
                <div class="menu-dropdown styled-dropdown" v-show="showQList">
                  <q-list class="q-pa-none" link no-border v-if="total > 0" >
                      <q-item v-if="toExpire > 0" @click.native="notificationsButtonClick" exact :to="userRoleURL + 'orders/in-lending?page=1&sort_by&descending=true&per_page=10&search=&filterTab=PRESTAMOS_QUE_VENCEN'">
                        <q-item-side icon="how_to_reg" />
                        <q-item-main>
                          <q-item-tile label>{{ $T('Orders expiring soon') }}</q-item-tile>
                        </q-item-main>
                        <q-item-side right>
                          <q-item-tile label>{{ toExpire }}</q-item-tile>
                        </q-item-side>
                      </q-item>
                      <q-item v-if="expiredNotClosed > 0" @click.native="notificationsButtonClick" exact :to="userRoleURL + 'orders/in-lending?page=1&sort_by&descending=true&per_page=10&search=&filterTab=PRESTAMOS_VENCIDOS'">
                        <q-item-side icon="restore" />
                        <q-item-main>
                          <q-item-tile label>{{ $T('Overdue orders that have not been closed') }}</q-item-tile>
                        </q-item-main>
                        <q-item-side right>
                          <q-item-tile label>{{ expiredNotClosed }}</q-item-tile>
                        </q-item-side>
                      </q-item>
                      <q-item v-if="kitsPendingReception > 0" @click.native="notificationsButtonClick" exact :to="userRoleURL + 'lending-kits?page=1&sort_by&descending=false&per_page=5&search=&filterTab=PENDING_RECEPTION'">
                        <q-item-side icon="how_to_vote" />
                        <q-item-main>
                          <q-item-tile label>{{ $T('Pending kits to receive') }}</q-item-tile>
                        </q-item-main>
                        <q-item-side right>
                          <q-item-tile label>{{ kitsPendingReception }}</q-item-tile>
                        </q-item-side>
                      </q-item>
                    </q-list>

                </div>
              </div>
              <!-- <q-icon color="primary" name="fa icon-notification">
              </q-icon>
              <q-chip :id="total > 0 && show ? 'notificationChip' : ''" class="chip-notification"  color="highlight" text-color="primary" :class="total > 0 && show ? '' : 'hidden'">{{ total }}</q-chip> -->
              <!-- <q-btn-dropdown
                  v-if="user && notificationEnabled === '1' && user.role && (user.role.name === 'Sales Expert' || user.role.name === 'Lending Point')"
                  :round="isMobile"
                  :rounded="!isMobile"
                  flat>
                 -->
              <!-- </q-btn-dropdown> -->

              <div class="row q-ml-sm">
                <!-- User -->
                <v-button flat dense rounded color="primary" v-if="user" tour="briefing-4"
                          :tour-title="$T('profile settings')"
                          :tour-content="$T('click here to access your profile settings')">
                    <svg class="lt-md" width="17" height="21" viewBox="0 0 17 21" fill="none"><path d="M12 12.5H4.5C2.567 12.5 1 14.067 1 16C1 17.933 2.567 19.5 4.5 19.5H12C13.933 19.5 15.5 17.933 15.5 16C15.5 14.067 13.933 12.5 12 12.5Z" stroke="#34303D" stroke-width="1.5"/><path d="M8.25 9C10.4591 9 12.25 7.20914 12.25 5C12.25 2.79086 10.4591 1 8.25 1C6.04086 1 4.25 2.79086 4.25 5C4.25 7.20914 6.04086 9 8.25 9Z" stroke="#34303D" stroke-width="1.5"/></svg>

                    <span class="gt-sm on-right q-pr-sm capitalize">
                        {{ user.name | firstAndLast }}
                        - {{ user.role.name }}
                    </span>
                    <q-popover fit>
                        <q-list dense link>
    <!--                        <q-item @click.native="$router.push({ name: 'settings.profile' })" v-close-overlay>-->
    <!--                            <q-item-side icon="settings"/>-->
    <!--                            {{ $T('settings') }}-->
    <!--                        </q-item>-->
                            <q-item class="lt-md no-pointer-events">
                                <!-- <q-item-side icon="account_circle"/> -->
                                <q-item-side>
                                  <svg width="17" height="21" viewBox="0 0 17 21" fill="none"><path d="M12 12.5H4.5C2.567 12.5 1 14.067 1 16C1 17.933 2.567 19.5 4.5 19.5H12C13.933 19.5 15.5 17.933 15.5 16C15.5 14.067 13.933 12.5 12 12.5Z" stroke="#34303D" stroke-width="1.5"/><path d="M8.25 9C10.4591 9 12.25 7.20914 12.25 5C12.25 2.79086 10.4591 1 8.25 1C6.04086 1 4.25 2.79086 4.25 5C4.25 7.20914 6.04086 9 8.25 9Z" stroke="#34303D" stroke-width="1.5"/></svg>
                                </q-item-side>
                                {{ user.name | firstAndLast }} - {{ user.role.name }}
                            </q-item>
                            <q-item @click.native="logout" v-close-overlay>
                                <q-item-side icon="exit to app"/>
                                {{ $T('log out') }}
                            </q-item>
                        </q-list>
                    </q-popover>
                </v-button>

                <!-- Help -->
                <!-- <v-button flat dense round @click="$tours['helpTour'].start()"
                          color="primary" icon="live help" :class="isMobile ? 'hidden' : ''"></v-button> -->

                <locale-dropdown  class="gt-sm"
                                  tour="briefing-7"
                                :tour-title="$T('language')"
                                :tour-content="$T('click here to change the language')"></locale-dropdown>

            </div>

              </div>

        </q-toolbar>
    </div>
</template>

<script>
    import axios from 'axios'
    import {mapGetters} from 'vuex'
    import LocaleDropdown from './LocaleDropdown'
    import LendingPointDropdown from './DropdownLendingPoint'
    import {
        QToolbar,
        QToolbarTitle,
        QIcon,
        QList,
        QItem,
        QItemSide,
        QChip,
        QPopover,
        QPageSticky,
        QFab,
        QFabAction,
        QTooltip
    } from 'quasar-framework'
    import store from "../store";

    export default {
        data: () => ({
            appName: window.config.appName,
            refreshTimer: null,
            mockData: null,
            isMobile: false,
            notificationEnabled: false,
            userRoleURL: '',
            showQList: false,
            removeLogo: false
        }),

        props:{
          sideMenuOpen:{
            type: Boolean
          },
          noBorder: Boolean
        },

        computed: mapGetters({
            user: 'auth/user',
            total: 'notifications/total',
            toExpire: 'notifications/toExpire',
            expiredNotClosed: 'notifications/expiredNotClosed',
            kitsPendingReception: 'notifications/kitsPendingReception'

        }),

        components: {
            LocaleDropdown,
            LendingPointDropdown,
            QToolbar,
            QToolbarTitle,
            QIcon,
            QList,
            QItem,
            QItemSide,
            QChip,
            QPopover,
            QFab,
            QFabAction,
            QPageSticky,
            QTooltip
        },

        methods: {
            async logout() {
                // Log out the user.
                await this.$store.dispatch('auth/logout')

                // Redirect to login.
                //this.$router.push({name: 'login'})
                window.location.href = '/login'
            },
          async getNotificationData() {
            const {data} = await axios.get(`${config.appUrl}/api/v1/notifications`)
            this.mockData = data.data
            this.notificationEnabled = this.mockData.enabled
            this.$store.commit('notifications/setEnabled', this.notificationEnabled)
            this.$store.commit('notifications/setToExpire', this.mockData.ordersToExpire)
            this.$store.commit('notifications/setExpiredNotClosed', this.mockData.ordersExpiredNotClosed)
            this.$store.commit('notifications/setKitsPendingReception', this.mockData.kitsPendingReception)
          },
          notificationsButtonClick(){
            this.showQList = !this.showQList
          },
          isHome(){
            if(this.$route.name === 'home' && !this.isMobile){
              this.$emit('menuHome')
            } else {
              this.$emit('leftDrawerToogle')
            }
          }
        },
      created() {
        let user = store.getters['auth/user']
        if (user.role.name === 'Sales Expert' || user.role.name === 'MUPI' || user.role.name == 'Remote Coach' || user.role.name === 'Lending Point') {
          this.refreshTimer = setInterval(this.getNotificationData, 30 * 1000)
        }
        if (user.role.name === 'Sales Expert' || user.role.name === 'MUPI' || user.role.name == 'Remote Coach') {
          this.userRoleURL = '/sales-expert/'
        }
        if (user.role.name === 'Lending Point') {
          this.userRoleURL = '/lending-point/'
        }
      },
      mounted() {
        this.isMobile = this.$q.platform.is.mobile || this.$q.platform.is.ipad || this.$q.platform.is.platform === 'ipad' || this.$q.platform.has.touch
        let user = store.getters['auth/user']
        if (user.role.name === 'Sales Expert' || user.role.name === 'MUPI' || user.role.name == 'Remote Coach' || user.role.name === 'Lending Point') {
          this.getNotificationData()
        }
      },
      watch:{
        sideMenuOpen(value){
          this.removeLogo = !value
        },
        noBorder(value){
          if(value){
            document.getElementsByClassName('q-layout-header')[0].style.boxShadow = '295px 7px 6px -6px rgb(52 48 61 / 40%)'
          }else{
            document.getElementsByClassName('q-layout-header')[0].style.boxShadow = '0px 7px 6px -6px rgb(52 48 61 / 40%)'
          }
        }
      },
      destroyed() {
        clearInterval(this.refreshTimer)
      }
    }
</script>
<style scoped lang="stylus">
.mobile-drop-down
  width fit-content
  font-size 14px
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Navbar.vue